export default __webpack_public_path__ + "static/media/hardwareUps.5356d97e.png";